import React from 'react';

const MasterContext = React.createContext();

export default MasterContext;